import { Logo } from "./Logo";
import { LINKS } from "../config";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t, isAr } = useLang();
  return (
    <footer className="bg-forest text-paper pt-20 pb-10 px-6 md:px-12" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto">
        <Logo onDark />
        <p
          className="font-display font-light text-[16vw] md:text-[10vw] leading-none text-outline-gold select-none mt-8"
          data-testid="footer-wordmark"
          dir="ltr"
        >
          SIPSATION
        </p>
        <div className="mt-12 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <p className={`${t.footer.taglineMainArabic ? "font-arabic" : "font-display italic"} text-gold text-2xl`}>{t.footer.taglineMain}</p>
            <p className="text-paper/50 text-sm mt-2">{t.footer.taglineSub}</p>
          </div>
          <div className="flex gap-8 text-xs uppercase tracking-[0.2em] text-paper/60">
            <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors duration-300" data-testid="footer-instagram-link">{t.footer.instagram}</a>
            <a href={LINKS.talabat} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors duration-300" data-testid="footer-talabat-link">{t.footer.talabat}</a>
            <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors duration-300" data-testid="footer-whatsapp-link">{t.footer.whatsapp}</a>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-paper/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-paper/40">
          <span>{t.footer.rights(new Date().getFullYear())}</span>
          <span>{t.footer.brewed}</span>
        </div>
      </div>
    </footer>
  );
};
